import Vue from 'vue'
import Provider from './Provider.vue'
import ProviderFinances from './ProviderFinances.vue'
import ProviderBankData from './ProviderBankData.vue'
import ProviderRelationship from './ProviderRelationship.vue'
import ProviderMigration from './ProviderMigration.vue'

const ProviderComponent = Vue.extend(Provider)
const ProviderFinancesComponent = Vue.extend(ProviderFinances)
const ProviderBankDataComponent = Vue.extend(ProviderBankData)
const ProviderRelationshipComponent = Vue.extend(ProviderRelationship)
const ProviderMigrationComponent = Vue.extend(ProviderMigration)
export default {
  openProvider (propsData) {
    return new ProviderComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openProviderFinances (propsData) {
    return new ProviderFinancesComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openProviderBankData (propsData) {
    return new ProviderBankDataComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openProviderRelationship (propsData) {
    return new ProviderRelationshipComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openProviderMigration (propsData) {
    return new ProviderMigrationComponent({
      el: document.createElement('div'),
      propsData
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/customer/Provider.js